export default "__VITE_ASSET__zUdiPR1g__"